import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

function ChangeInfo() {
    const state = useSelector((state) => state.change.value);
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = `${month}/${date}/${year}`;

    return (
        <Card
                          sx={{
                            flex: 2,
                            maxWidth: 800,
                            // minWidth: { xs: "100%", md: 400 },
                            boxShadow: 3,
                            borderRadius: 3,
                            border: "1px solid #ddd",
                            mt: { xs: 3, md: 0 },
                            backgroundColor:'goldenrod'
                          }}
                        >
            <CardContent>
                <Box sx={{ mb: 2 }}>
                                      <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                                        Montants de l'opération
                                      </Typography>

                                    </Box>
                <Stack direction="column" spacing={1} >
                    <Box>
                        <Typography variant="body2">
                            Vous {state.typeOperation === "achat" ? "vendez" : "achetez"} un montant de{" "}
                            <strong>
                                {state.typeOperation === "achat"
                                    ? `${state.montantToExchane} ${state.cour.devise.name}`
                                    : `${state.MontantToReceive} ${state.cour.devise.name}`}
                            </strong>
                        </Typography>
                        <Typography variant="body2">
                            contre un montant de{" "}
                            <strong>
                                {state.typeOperation === "achat"
                                    ? `${state.MontantToReceive} MAD`
                                    : `${state.montantToExchane} MAD`}
                            </strong>
                        </Typography>
                        <Typography variant="body2">
                            avec le taux : 1 {state.cour.devise.name} ={" "}
                            {state.typeOperation === "achat"
                                ? `${Number(state.cour.prixAchat).toFixed(2)}`
                                : `${Number(state.cour.prixVente).toFixed(2)}`}{" "}
                            MAD
                        </Typography>
                    </Box>

                    {/* Affichage de la date actuelle */}
                    <Box>
                        <Typography variant="caption" sx={{ color: 'black', fontStyle: 'italic' }}>
                            📅 Le {currentDate}
                        </Typography>
                    </Box>
                </Stack>
            </CardContent>
        </Card>
    );
}

export default ChangeInfo;
